export default "__VITE_ASSET__BBXh8t99__"